'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loading;

var count = 0;

function loading(action) {
  // action: add, sub
  if (action === 'add') {
    count += 1;
  } else {
    count -= 1;
  }

  if (count <= 0) {
    count = 0;
  }

  var node = document.querySelector('#global-loading');
  if (node) {
    node.style.display = count > 0 ? '' : 'none';
  }
}